import Icon from '@/components/snippets/icon/icon'
import { FilterItem } from 'libs/searchspring/components/collection/filters/FilterItem'
import { FilterSelected } from 'libs/searchspring/components/collection/filters/FilterSelected'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { useInfiniteScrollResults } from 'libs/searchspring/hooks/useInfiniteScrollResults'
import { useEffect, useRef } from 'preact/hooks'

export function FilterDrawer({ id = 'filters', showFilters = false }) {
  const {
    handleClearFilters,
    handleToggleFilter,
    handleRemoveFilter,
    initialFilters,
    activeFilters,
    fetchedFilters
  } = useFilters()

  const { results, isLoading } = useInfiniteScrollResults()
  const totalResults = results?.pagination?.totalResults || 0
  const initialLoadDone = useRef(false)
  const isDesktop = useRef(window.innerWidth >= 1024)

  useEffect(() => {
    if (showFilters && isDesktop.current && !initialLoadDone.current && !isLoading && results) {
      document.querySelector('#toggle-filters')?.click()
      initialLoadDone.current = true
    }
  }, [isLoading, results, showFilters])

  return (
    <x-modal
      className="group/filters lg-max:z-60"
      data-id={id}
    >
      <div className="flex flex-col fixed lg:sticky top-0 lg:top-header-adapt left-0 w-full lg:w-0 group-data-visible/filters:lg:w-grid-1/4-window group-data-visible/filters:xl:w-grid-1/5-window group-data-visible/filters:xxxl:w-grid-1/6-window h-view lg:h-fit lg:py-0.5 pointer-events-none group-data-visible/filters:pointer-events-auto lg-max:z-60 transition-all">
        <div
          className="flex flex-col w-full lg:w-grid-1/4-window xl:w-grid-1/5-window xxxl:w-grid-1/6-window lg-max:h-full lg-max:max-w-[335px] lg:pr-1.5 lg-max:bg-secondary -translate-x-full-margin group-data-visible/filters:translate-x-0 z-2 transition-all"
        >
          <div className="shrink-0 flex lg:hidden gap-x-gutter items-center justify-between w-full h-[60px] px-margin border-b border-neutral-medium">
            <h2 className="h6 font-medium">Filters</h2>
            <button
              className="size-[13px] children:size-full"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="Close Filters"
            >
              <Icon id="close" />
            </button>
          </div>
          <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
          <div className="grow flex flex-col overflow-y-scroll no-scrollbar overscroll-none">
            {initialFilters.length > 0 ? (
              initialFilters.map((filter) => (
                <FilterItem
                  filter={filter}
                  onFilter={handleToggleFilter}
                  fetchedFilters={fetchedFilters}
                  activeFilters={activeFilters}
                  key={filter.field}
                />
              ))
            ) : (
              <p className="lg-max:px-margin py-1 text-neutral-secondary">No filters available</p>
            )}
          </div>
          <div className="shrink-0 flex lg:hidden gap-x-gutter w-full px-margin py-1 bg-neutral-light pb-2.5">
            {activeFilters.size > 0 && (
              <button
              className="btn btn-primary btn-border btn-m btn-bold"
              onClick={handleClearFilters}
              aria-label="Clear Filters"
            >
              Clear
            </button>
            )}
            <button
              className="grow btn btn-primary btn-fill btn-m btn-bold"
              data-modal-parent={id}
              data-modal-role="close"
              aria-label="View Results"
            >
              View {totalResults} Results
            </button>
          </div>
        </div>
        <button
            class="lg:hidden fixed inset-tl size-full bg-neutral-black/60 opacity-0 group-data-visible/filters:opacity-100 pointer-events-none group-data-visible/filters:pointer-events-auto cursor-w-resize transition-all"
            data-modal-parent={id}
            data-modal-role="close"
            aria-label="Close Filters"
          >
          </button>
      </div>
    </x-modal>
  )
}
